import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import {
  fieldsToGqlString,
  mergeByIdNewAtTop,
} from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultSaiBankReconFields = {
  _id: '',
  fiscalYear: '',
  asOfDate: '',
  comment: '',
  generalLedgerBalance: '',
  isSaiMonthly: '',
  bank: {
    _id: '',
    accountNumber: '',
    altKeyBase: '',
    bankCode: '',
    bankName: '',
    groupCode: '',
    routingNumber: '',
    bankAddress: '',
  },
  details: {
    description: '',
    addDeduct: '',
    amount: '',
    type: '',
    detailsFiscalYear: '',
    bankCode: {
      _id: '',
      description: '',
      addDeduct: '',
    },
  },
};

export const saiBankReconciliation = {
  namespaced: true,
  state: () => ({
    regYears: {},
  }),
  mutations: {
    setFiscalRegYears(state, regYears) {
      state.regYears = regYears;
    },
  },
  actions: {
    async loadSaiBankReconTrans({ commit, dispatch }, {
      criteria, fields, baseCrudKey, postProccessBankReconciliation,
    }) {
      let results;
      const gqlfields = fields || defaultSaiBankReconFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query saiBankReconciliation($criteria: saiBankReconciliationCriteriaType) {
            saiBankReconciliation(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',

        });
        clients.handleGQLErrors(results, commit);
        const bankReconTrans = results.data ? results.data.saiBankReconciliation || [] : [];
        const postProcessedTrans = postProccessBankReconciliation
          ? postProccessBankReconciliation(bankReconTrans) : bankReconTrans;
        commit('base/crud/setItems', [baseCrudKey, postProcessedTrans], { root: true });
        return postProcessedTrans;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
    async upsertSaiBankReconTrans({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey, postProccessBankReconciliation,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultSaiBankReconFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertSaiBankReconciliation ($item: saiBankReconciliationInputType!)  {
                upsertSaiBankReconciliation(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const bankReconTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const bankRecon = results.data ? results.data.upsertSaiBankReconciliation || {} : {};
        const newTransaction = postProccessBankReconciliation
          ? (postProccessBankReconciliation(bankRecon)) : bankRecon;
        const newList = mergeByIdNewAtTop(bankReconTransStateData || [], newTransaction);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async deleteSaiBankReconTrans({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteSaiBankReconciliation ($id: ID!)  {
            deleteSaiBankReconciliation(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data ? (results.data.deleteSaiBankReconciliation || {})._id : null;
        const bankReconTransData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = bankReconTransData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        return delId;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
      return null;
    },
    async loadFiscalRegYears({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            saiBankReconciliationStatsFYRange { max, min },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const range = results.data ? (results.data.saiBankReconciliationStatsFYRange || {}) : null;
        commit('setFiscalRegYears', results.data.saiBankReconciliationStatsFYRange);
        return range;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max Fiscal Year ranges.', { root: true });
      }
      return null;
    },
    async saiBankReconGatherInformation({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query
          saiBankReconGatherInformation ($criteria: saiBankReconGatherInfoCriteriaType) {
            saiBankReconGatherInformation(criteria: $criteria) {
              status
            },
          }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.saiBankReconGatherInformation || {}) : {};
        console.info(results.data, 'res');
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while collecting GL information.', { root: true });
      }
      return null;
    },
  },
};

export default saiBankReconciliation;
